// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as InstaMojoModal from "../../../live-order-dashboard/components/modals/InstaMojoModal.bs.js";

function getModalComponent(modalState, toggleModal) {
  var closeModal = function (param) {
    return Curry._1(toggleModal, (function (param) {
                  
                }));
  };
  if (modalState !== undefined) {
    return React.createElement(InstaMojoModal.make, {
                orderId: modalState.order_id,
                toggleModal: closeModal
              });
  } else {
    return null;
  }
}

function useModal(param) {
  var match = React.useState(function () {
        
      });
  var toggleModal = match[1];
  var modal_component = getModalComponent(match[0], toggleModal);
  var open_modal = function (modal) {
    return Curry._1(toggleModal, (function (param) {
                  return modal;
                }));
  };
  return [
          modal_component,
          open_modal
        ];
}

export {
  getModalComponent ,
  useModal ,
  
}
/* react Not a pure module */
